import React from 'react';

import { useDispatch, useSelector } from "react-redux";

const PreloaderHomeFilter = () => {

    const theme = useSelector((state) => state.initData.theme);

    return (
        <>
            {
                theme == 'dark' && (
                    <svg width="961" height="40" viewBox="0 0 961 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g filter="url(#filter0_b_0_96)">
                        <rect width="111" height="40" rx="12" fill="#2C2C2E"/>
                        </g>
                        <g filter="url(#filter1_b_0_96)">
                        <rect x="119" width="162" height="40" rx="12" fill="#2C2C2E"/>
                        </g>
                        <g filter="url(#filter2_b_0_96)">
                        <rect x="289" width="162" height="40" rx="12" fill="#2C2C2E"/>
                        </g>
                        <g filter="url(#filter3_b_0_96)">
                        <rect x="459" width="162" height="40" rx="12" fill="#2C2C2E"/>
                        </g>
                        <g filter="url(#filter4_b_0_96)">
                        <rect x="629" width="162" height="40" rx="12" fill="#2C2C2E"/>
                        </g>
                        <g filter="url(#filter5_b_0_96)">
                        <rect x="799" width="162" height="40" rx="12" fill="#2C2C2E"/>
                        </g>
                        <defs>
                        <filter id="filter0_b_0_96" x="-40" y="-40" width="191" height="120" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_96"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_96" result="shape"/>
                        </filter>
                        <filter id="filter1_b_0_96" x="79" y="-40" width="242" height="120" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_96"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_96" result="shape"/>
                        </filter>
                        <filter id="filter2_b_0_96" x="249" y="-40" width="242" height="120" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_96"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_96" result="shape"/>
                        </filter>
                        <filter id="filter3_b_0_96" x="419" y="-40" width="242" height="120" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_96"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_96" result="shape"/>
                        </filter>
                        <filter id="filter4_b_0_96" x="589" y="-40" width="242" height="120" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_96"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_96" result="shape"/>
                        </filter>
                        <filter id="filter5_b_0_96" x="759" y="-40" width="242" height="120" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_96"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_96" result="shape"/>
                        </filter>
                        </defs>
                    </svg>
                ) || (
                    <svg width="961" height="40" viewBox="0 0 961 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g filter="url(#filter0_b_0_96)">
                        <rect width="111" height="40" rx="12" fill="#E9E9EB"/>
                        </g>
                        <g filter="url(#filter1_b_0_96)">
                        <rect x="119" width="162" height="40" rx="12" fill="#E9E9EB"/>
                        </g>
                        <g filter="url(#filter2_b_0_96)">
                        <rect x="289" width="162" height="40" rx="12" fill="#E9E9EB"/>
                        </g>
                        <g filter="url(#filter3_b_0_96)">
                        <rect x="459" width="162" height="40" rx="12" fill="#E9E9EB"/>
                        </g>
                        <g filter="url(#filter4_b_0_96)">
                        <rect x="629" width="162" height="40" rx="12" fill="#E9E9EB"/>
                        </g>
                        <g filter="url(#filter5_b_0_96)">
                        <rect x="799" width="162" height="40" rx="12" fill="#E9E9EB"/>
                        </g>
                        <defs>
                        <filter id="filter0_b_0_96" x="-40" y="-40" width="191" height="120" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_96"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_96" result="shape"/>
                        </filter>
                        <filter id="filter1_b_0_96" x="79" y="-40" width="242" height="120" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_96"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_96" result="shape"/>
                        </filter>
                        <filter id="filter2_b_0_96" x="249" y="-40" width="242" height="120" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_96"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_96" result="shape"/>
                        </filter>
                        <filter id="filter3_b_0_96" x="419" y="-40" width="242" height="120" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_96"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_96" result="shape"/>
                        </filter>
                        <filter id="filter4_b_0_96" x="589" y="-40" width="242" height="120" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_96"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_96" result="shape"/>
                        </filter>
                        <filter id="filter5_b_0_96" x="759" y="-40" width="242" height="120" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_0_96"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_0_96" result="shape"/>
                        </filter>
                        </defs>
                        </svg>
                )
            }
        </>
    )   
}

export default PreloaderHomeFilter;